import { render, staticRenderFns } from "./fieldAwesomeButton.vue?vue&type=template&id=5455de92&v-if=componentAccess.canEdit.access&"
import script from "./fieldAwesomeButton.vue?vue&type=script&lang=js&"
export * from "./fieldAwesomeButton.vue?vue&type=script&lang=js&"
import style0 from "./fieldAwesomeButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports